import React from "react";
import { colors } from "../../../../../../../../themes/Colors";
import { BaseButtons } from "../../../../../../../common-components";

const AgencyItemDisplay = () => {
  return (
    <div
      style={{
        width: "90%",
        maxWidth: 400,
        borderRadius: 8,
        borderStyle: "solid",
        borderWidth: 3,
        borderColor: colors.greenLight,
        backgroundColor: colors.white,
        WebkitBoxShadow: "0px 0px 7px 2px #00000050",
        minHeight: 150,
        position: "relative",
        marginTop: 20,
        display: "flex",
      }}
    >
      <div
        style={{
          heigh: "100%",
          minWidth: 120,
          maxWidth: 120,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        IMAGE LOGO
      </div>
      <div>
        <div
          style={{
            fontWeight: "bold",
            marginTop: 4,
            marginBottom: 3,
            overflow: "hidden",
          }}
        >
          company name
        </div>
        <div style={{ overflow: "hidden", width: "90%" }}>
          <div style={{ fontSize: 12, fontWeight: "bold", opacity: 0.7 }}>
            Services:
          </div>
          <div
            style={{
              display: "flex",
              overflow: "hidden",
              width: "100%",
              flexWrap: "wrap",
              fontSize: 14,
              marginTop: 3,
            }}
          >
            <div style={{ marginLeft: 5 }}>Fines</div>
            <div style={{ marginLeft: 5 }}>Lisense</div>
            <div style={{ marginLeft: 5 }}>Sales</div>
            <div style={{ marginLeft: 5 }}>Valuations</div>
            <div style={{ marginLeft: 5 }}>spares</div>
            <div style={{ marginLeft: 5 }}>services</div>
            <div style={{ marginLeft: 5 }}>auto-motive fitment</div>
            <div style={{ marginLeft: 5 }}>towing</div>
          </div>
        </div>
        <div>
          <div
            style={{
              fontSize: 12,
              fontWeight: "bold",
              opacity: 0.7,
              marginTop: 3,
            }}
          >
            operating since:
          </div>
          <div style={{ fontSize: 14, marginTop: 3 }}>
            <div style={{ marginLeft: 5 }}>{new Date().toDateString()}</div>
          </div>
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          width: "100%",
          bottom: -30,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <BaseButtons
          label={"VIEW"}
          width={"95%"}
          borderRadius={8}
          backgroundColor={colors.greenLight}
        />
      </div>
    </div>
  );
};

export default AgencyItemDisplay;
